"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by gevorg.avetisyan on 5/3/2018.
 */
var core_1 = require("@angular/core");
var name_template_service_1 = require("./name-template.service");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var path_helper_1 = require("./config/path.helper");
var from_1 = require("rxjs/observable/from");
var operators_1 = require("rxjs/operators");
var HttpNameTemplateService = /** @class */ (function (_super) {
    __extends(HttpNameTemplateService, _super);
    function HttpNameTemplateService(http, applicationPropertiesService) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.meServiceUriKey = "me-de-service-url";
        _this.meServiceUri$ = from_1.from(_this.applicationPropertiesService.getProperty(_this.meServiceUriKey));
        return _this;
    }
    HttpNameTemplateService.prototype.getNameTemplates = function () {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.RESULT_AREA); }));
    };
    HttpNameTemplateService.prototype.getNameTemplate = function (id) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.get(url + path_helper_1.PathHelper.RESULT_AREA + id); }));
    };
    HttpNameTemplateService.prototype.createNameTemplate = function (rfLevel) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.post(url + path_helper_1.PathHelper.RESULT_AREA, rfLevel); }));
    };
    HttpNameTemplateService.prototype.updateNameTemplate = function (rfLevel) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.RESULT_AREA, rfLevel); }));
    };
    HttpNameTemplateService.prototype.deleteNameTemplate = function (id) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.delete(url + path_helper_1.PathHelper.RESULT_AREA + id); }));
    };
    HttpNameTemplateService.prototype.canDeleteNameTemplate = function (id) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) { return _this.http.put(url + path_helper_1.PathHelper.RESULT_AREA_CHECK + id, {}); }));
    };
    HttpNameTemplateService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpNameTemplateService);
    return HttpNameTemplateService;
}(name_template_service_1.NameTempalteService));
exports.HttpNameTemplateService = HttpNameTemplateService;
//# sourceMappingURL=http-name-template.service.js.map